module.exports = __webpack_public_path__ + "media/crosses/blue-cross-90aa7dd9.svg";